"use client"

import {
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query"
import { useState } from "react"

export default function ApiProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5, // 5 min
            gcTime: 1000 * 60 * 10 // cache garbage collection
          },
          mutations: {
            retry: 0
          }
        }
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}